import { useMemo, useState } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { useGetPeerReviewQuery } from "../../../../api/employeeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
const PeerReview = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const navigate = useNavigate();
  const user = GetLocalStorage();
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const handleView = (id, referenceId) => {
    if (id) {
      navigate(`${id}/view/${referenceId}`);
    }
  };
  const { data, isLoading } = useGetPeerReviewQuery({
    AppraiserId: user?.staffId,
    PageNumber: currentPage,
    PageSize: pageSize,
    SearchTerm: searchText,
    PeriodStartDate: startDate,
    PeriodEndDate: endDate,
  });

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!data?.responseObject?.pageItems) return [];
    return [...data.responseObject.pageItems].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      // For strings, make case-insensitive
      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data?.responseObject?.pageItems, sortColumn, sortDirection]);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return <FaSort className="ml-1" />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ml-1" />
    ) : (
      <FaSortDown className="ml-1" />
    );
  };
  return (
    <PageStyle
      hasBack={true}
      backURL={`/dashboard/employee/performance-appraisal`}
      demoTitle={"Peer Review"}
      hasTopPageDemo
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th
                onClick={() => handleSort("appraiseeName")}
                style={{ cursor: "pointer" }}
              >
                Appraisee Name {renderSortIcon("appraiseeName")}
              </th>
              <th
                onClick={() => handleSort("appraiseeDepartment")}
                style={{ cursor: "pointer" }}
              >
                Department {renderSortIcon("appraiseeDepartment")}
              </th>
              <th
                onClick={() => handleSort("appraiseeDesignation")}
                style={{ cursor: "pointer" }}
              >
                Job Title {renderSortIcon("appraiseeDesignation")}
              </th>
              <th>Appraisal Period</th>
              {/* <th
                onClick={() => handleSort("slaDueDate")}
                style={{ cursor: "pointer" }}
              >
                SLA Due Date {renderSortIcon("slaDueDate")}
              </th> */}
              <th
                onClick={() => handleSort("status")}
                style={{ cursor: "pointer" }}
              >
                Status {renderSortIcon("status")}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={6} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
            {sortedData?.length > 0 &&
              sortedData?.map((item, index) => (
                <tr key={index + 1}>
                  <td>{index + 1}</td>
                  <td>{item?.appraiseeName}</td>
                  <td>{item?.department}</td>
                  <td>{item?.jobTitle}</td>
                  <td>{item?.appraisalPeriodDisplay}</td>
                  {/* <td>{FormatDateTime(item.slaDueDate, "DD/MM/YYYY")}</td> */}
                  <td>{item?.status}</td>
                  <td>
                    <TableActions
                      hasChildren={true}
                      url={`${item.reviewId}/view/${item.referenceId}`}
                    >
                      {[
                        {
                          name: "View",
                          action: () =>
                            handleView(item.reviewId, item.referenceId),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))}
            {sortedData?.length === 0 && !isLoading && (
              <tr>
                <td colSpan={6} className="text-center">
                  No Peer Review Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        // last_page={data?.totalPages}
        // present_page={data?.currentPage}
        // totalRows={data?.totalRows}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
    </PageStyle>
  );
};

export default PeerReview;
